// src/services/soundService.js

class SoundService {
  constructor() {
    this.audio = null;
    this.repeatInterval = null;
    this.isPlaying = false;
    this.currentSoundFile = null;
  }

  playSound(soundFile = 'bell-loud.mp3', volume = 1.0) {
    const soundEnabled = this.getSoundPreference();
    if (!soundEnabled) {
      console.log('Sound disabled by user');
      return;
    }

    try {
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }

      this.audio = new Audio(`/sounds/${soundFile}`);
      this.audio.volume = volume;
      
      this.audio.play()
        .then(() => {
          console.log('Sound playing:', soundFile);
          this.isPlaying = true;
        })
        .catch(err => {
          console.error('Sound play failed:', err);
          console.warn('Tip: User interaction may be required to play sounds');
        });
    } catch (error) {
      console.error('Error playing sound:', error);
    }
  }

  startRepeatingSound(soundFile, intervalSeconds, volume = 1.0) {
    const soundEnabled = this.getSoundPreference();
    if (!soundEnabled) {
      console.log('Sound disabled by user - not starting repeat');
      return;
    }

    this.stopRepeatingSound();
    this.currentSoundFile = soundFile;
    this.playSound(soundFile, volume);

    this.repeatInterval = setInterval(() => {
      console.log('Repeating sound:', soundFile);
      this.playSound(soundFile, volume);
    }, intervalSeconds * 1000);

    console.log(`Started repeating sound every ${intervalSeconds} seconds`);
  }

  stopRepeatingSound() {
    if (this.repeatInterval) {
      clearInterval(this.repeatInterval);
      this.repeatInterval = null;
      console.log('Stopped repeating sound');
    }

    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
    }

    this.isPlaying = false;
    this.currentSoundFile = null;
  }

  vibrate(pattern = [300, 100, 300, 100, 500]) {
    const vibrationEnabled = this.getVibrationPreference();
    if (!vibrationEnabled) {
      console.log('Vibration disabled by user');
      return;
    }

    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
      console.log('Vibrating with pattern:', pattern);
    } else {
      console.warn('Vibration not supported on this device');
    }
  }

  getSoundPreference() {
    const pref = localStorage.getItem('waiter_sound_enabled');
    return pref === null ? true : pref === 'true';
  }

  getVibrationPreference() {
    const pref = localStorage.getItem('waiter_vibration_enabled');
    return pref === null ? true : pref === 'true';
  }

  setSoundPreference(enabled) {
    localStorage.setItem('waiter_sound_enabled', enabled.toString());
    console.log('Sound preference set to:', enabled);
  }

  setVibrationPreference(enabled) {
    localStorage.setItem('waiter_vibration_enabled', enabled.toString());
    console.log('Vibration preference set to:', enabled);
  }

  isCurrentlyPlaying() {
    return this.isPlaying || this.repeatInterval !== null;
  }
}

export const soundService = new SoundService();